import { Component, signal } from '@angular/core';
import { AlertService } from '../../../../../core/services/alert.service';
import { AuthGuardService } from '../../../../../core/services/auth/auth-guard.service';
import { PostReportReasonEnum, PostReportReasonList } from '../../enum';
import { LandingPageDataService } from '../../services/landing-post-data.service';
import { LandingPostService } from '../../services/landing-post.service';
import { buildForm, DescriptionValidators } from './form';
import { first } from 'rxjs';

@Component({
  selector: 'app-report-post',
  templateUrl: './report-post.component.html',
  styleUrl: './report-post.component.scss',
  standalone: false
})
export class ReportPostComponent {
  isAllowReportModel = signal(false);
  isShowErrors = signal(false);

  postReportReasonList = PostReportReasonList;
  form = buildForm();
  PostReportReasonEnum = PostReportReasonEnum;

  constructor(
    private alertService: AlertService,
    public landingPageDataService: LandingPageDataService,
    private landingPostService: LandingPostService,
    private authGuardService: AuthGuardService,
  ) { }

  ngOnInit() {
    this.form.controls.reason.valueChanges.subscribe((v) => {
      if (this.form.getRawValue().reason == PostReportReasonEnum.OtherReasons) {
        this.form.controls.description.setValidators(DescriptionValidators);
      } else {
        this.form.controls.description.clearValidators();
        this.form.controls.description.reset();
      }
      this.form.controls.description.updateValueAndValidity();
    });
  }

  async submit() {
    if (this.form.invalid) {
      this.isShowErrors.set(true);
      return;
    }
    this.isShowErrors.set(false);
    await this.landingPostService.reportPost(
      this.landingPageDataService.details()._id,
      this.landingPageDataService.isQrCode(),
      this.form.getRawValue(),
    );
    this.form.reset();
    this.isAllowReportModel.set(false);
    this.alertService.suucess('Reported successfully');
  }

  createReport() {
    if (!this.authGuardService.isLoggedIn()) {
      var loginModalId = this.authGuardService.openLoginModalRequest();
      this.authGuardService.onLoginFromModel.pipe(first()).subscribe(loginrefId => {
        if (loginModalId == loginrefId)
          this.createReport();
      })
      return; return;
    }

    this.isAllowReportModel.set(true);
  }
}
